/* ERC B2B Wholesale Price Override v1.1 — ercluxury.com */
(function () {
  'use strict';

  var BY_ID = {
    '9468921446568': 67100,
    '9468921479336': 82100,
    '9468921512104': 160000,
    '9468921544872': 240000,
    '9468921577640': 240000,
    '9468921741480': 287000,
    '9468921774248': 224000,
    '9468921807016': 224000,
    '9468921839784': 303400,
    '9468921872552': 90000,
    '9468922200232': 63800,
    '9468922233000': 144000,
    '9468922265768': 168000,
    '9468922298536': 144000,
    '9468922331304': 89300,
    '9468922593448': 105000,
    '9468922626216': 120000,
    '9468922658984': 82100,
    '9468922691752': 287000,
    '9468922724520': 67100,
    '9468922855592': 67100,
    '9468922921128': 74600,
    '9468922953896': 287000,
    '9468922986664': 315700
  };

  var BY_HANDLE = {
    'gg-marmont-velvet-flap-bag': 67100,
    'dionysus-gg-supreme-shoulder-bag': 82100,
    'triomphe-shoulder-bag': 160000,
    'vintage-quilted-suede-top-handle-bag': 240000,
    'small-le-boy-chevron-bag': 240000,
    'business-affinity-flap-bag': 287000,
    'cuba-flap-bag-with-rainbow-hardware': 224000,
    'classic-mini-square-flap-bag': 224000,
    'cc-crown-caviar-leather-tote': 303400,
    'dionysus-large-top-handle-bag': 90000,
    'gg-marmont-small-shoulder-bag-so-black': 63800,
    'dauphine-hobo': 144000,
    'vanity-bb': 168000,
    'noe-bb-bucket-bag': 144000,
    'cluny-bb': 89300,
    'montaigne-bb': 105000,
    'pochette-metis-messenger-bag': 120000,
    'prada-pocket-shoulder-bag': 82100,
    'small-shearling-flap-bag': 287000,
    'galleria-saffiano-leather-bag': 67100,
    'galleria-saffiano-leather-bag-red': 67100,
    'serpenti-forever-crossbody-bag': 74600,
    'jypsiere-crossbody-bag': 287000,
    'toolbox-26': 315700
  };

  function fmt(cents) {
    var str = (cents / 100).toFixed(2);
    var parts = str.split('.');
    var int = parts[0];
    var out = '';
    for (var i = 0; i < int.length; i++) {
      if (i > 0 && (int.length - i) % 3 === 0) out += ',';
      out += int[i];
    }
    return '$' + out + '.' + parts[1] + ' USD';
  }

  /* Track which price-item elements we own and their target values */
  var _locked = new Map(); /* element -> target text */
  var _applying = false;

  function apply() {
    _applying = true;
    _locked = new Map();

    /* 1. Collection cards */
    var links = document.querySelectorAll('[id^="CardLink-"]');
    for (var i = 0; i < links.length; i++) {
      var parts = links[i].id.split('-');
      var pid = parts[parts.length - 1];
      var price = BY_ID[pid];
      if (!price) continue;
      var card = links[i].closest('.card-wrapper');
      if (!card) continue;
      var items = card.querySelectorAll('.price-item');
      for (var j = 0; j < items.length; j++) {
        var formatted = fmt(price);
        items[j].textContent = formatted;
        _locked.set(items[j], formatted);
      }
    }

    /* 2. Product detail page */
    var pm = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (pm) {
      var hprice = BY_HANDLE[pm[1]];
      if (hprice) {
        var pitems = document.querySelectorAll('.price-item');
        for (var k = 0; k < pitems.length; k++) {
          var formatted2 = fmt(hprice);
          pitems[k].textContent = formatted2;
          _locked.set(pitems[k], formatted2);
        }
      }
    }

    _applying = false;
  }

  /* MutationObserver: re-apply if WPD overwrites our locked prices */
  var _observer = null;
  function startObserver() {
    if (_observer) return;
    _observer = new MutationObserver(function (mutations) {
      if (_applying) return;
      var needsReapply = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var el = m.target;
        /* Check if the mutated element or its parent is a locked price-item */
        var priceEl = (el.classList && el.classList.contains('price-item'))
          ? el
          : (el.parentElement && el.parentElement.classList && el.parentElement.classList.contains('price-item'))
            ? el.parentElement
            : null;
        if (priceEl && _locked.has(priceEl) && priceEl.textContent !== _locked.get(priceEl)) {
          needsReapply = true;
          break;
        }
      }
      if (needsReapply) {
        setTimeout(apply, 30);
      }
    });
    _observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  /* Interval-based safety net: re-apply every 800ms for first 12 seconds */
  function startInterval() {
    var count = 0;
    var iv = setInterval(function () {
      apply();
      if (++count >= 15) clearInterval(iv);
    }, 800);
  }

  var CACHE_KEY = 'erc_ws1';
  var CACHE_TTL = 600000;

  function getCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (Date.now() - d.t < CACHE_TTL) return d.v;
    } catch (e) {}
    return null;
  }

  function setCache(v) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ v: v, t: Date.now() }));
    } catch (e) {}
  }

  function activate() {
    apply();
    startObserver();
    startInterval();
  }

  function init() {
    if (window.location.pathname.indexOf('/account') === 0) {
      try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
    }

    var cached = getCache();
    if (cached !== null) {
      if (cached) activate();
      return;
    }

    fetch('/pages/erc-b2b-gate', {
      credentials: 'include',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/id="erc-b2b-status">([^<]*)</);
        var isWholesale = !!(m && m[1].trim() === 'yes');
        setCache(isWholesale);
        if (isWholesale) activate();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }
})();
